import { Injectable } from '@angular/core';
import { IForm } from 'src/app/models/form.model';
import { Provider } from '../provider';

@Injectable()
export class FormService extends Provider<IForm>{
  protected url = "forms";
}
